import { memo } from "react";

import { Plus } from "./Plus";
import { animatedBackgroundGridSize } from "./utils";

interface AnimatedBackgroundBodyProps {
  columns: number;
  rows: number;
  opacityMatrix: string[][];
  color: string;
  bigger?: boolean;
}

export const AnimatedBackgroundBody: React.FC<AnimatedBackgroundBodyProps> =
  memo(({ columns, rows, opacityMatrix, color, bigger }) => {
    return Array.from({ length: columns }).map((_, x) =>
      Array.from({ length: rows }).map((_, y) => (
        <Plus
          x={x * animatedBackgroundGridSize + 5}
          y={y * animatedBackgroundGridSize + 5}
          scale={(y + 20) / (rows + 20) + (bigger ? 0.15 : 0)}
          key={`${x}-${y}`}
          color={`${color}${opacityMatrix[x][y]}`}
        />
      )),
    );
  });

AnimatedBackgroundBody.displayName = "AnimatedBackgroundBody";
